export const MIN_AMOUNT_COLUMNS = 1;
export const MAX_AMOUNT_COLUMNS = 4;

export const MIN_AMOUNT_ROWS = 1;
export const MAX_AMOUNT_ROWS = 12;

export const DEFAULT_COLUMN_PADDING = 16;
export const DEFAULT_ROW_PADDING = 16;
